import { useUserStore } from "@/store/modules/user";
import { useTagsViewStore } from "@/store/modules/tagsView";
import { useAppStore } from "@/store/modules/app";
import { usePermissionStore } from "@/store/modules/permission";

export function loginOutFuc() {
    const useStore = useUserStore();
    const tagsStore = useTagsViewStore();
    const appStore = useAppStore();
    const permissionStore = usePermissionStore();
    useStore.$reset() 
    tagsStore.$reset() 
    appStore.$reset() 
    permissionStore.$reset() 
}

  
